import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-admin-offices-add',
  templateUrl: './admin-offices-add.component.html'
})
export class AdminOfficesAddComponent implements OnInit {
  @Input() formdata;
  @Input() roles;
  @Input() types;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: [null, ''],
      abbreviation: ['', ''],
      name: ['', ''],
      officeTypeId: ['', ''],
      officeTypeName: ['', ''],
      sort: ['', ''],
      email: ['', ''],
      isActive: [true, ''],
      roleId: ['', ''],
      roleDescription: ['', '']
    });
  }
  
  setRole(evt) {
    this.form.patchValue({ roleId: evt.value });
  }

  setType(evt) {
    this.form.patchValue({ officeTypeId: evt.value });
  }

  saveOffice() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }

}
